import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoBackpackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_backpack"}/>
}
